<div class="error-state">
  <div class="error-state__content">
    <div class="error-state__header">
      <svg class="error-state__icon" viewBox="0 0 20 20" aria-hidden="true">
        <circle cx="10" cy="10" r="10" fill="currentColor" />
        <rect x="9" y="4.4" width="2" height="7" rx="1" fill="#fff" />
        <circle cx="10" cy="14.6" r="1.2" fill="#fff" />
      </svg>

      <h2 class="error-state__title">{{ title }}</h2>
    </div>
    <p class="error-state__lead">{{ description }}</p>

    <div class="error-state__help">
      <p class="error-state__help-title">{{ texts.helpTitle }}</p>
      <p class="error-state__help-text">
        {{ texts.helpCallStart
        }}<a [href]="contact.phone" class="error-state__link">{{ texts.helpPhone }}</a
        >{{ texts.helpWhatsappStart
        }}<a
          [href]="contact.whatsapp"
          target="_blank"
          rel="noopener"
          class="error-state__link"
          >{{ texts.helpWhatsapp }}</a
        >{{ texts.helpVideoStart
        }}<a [routerLink]="contact.videoCall" class="error-state__link">{{ texts.helpVideo }}</a>
      </p>
    </div>

    <div class="error-state__actions">
      <div *ngIf="canRetry" class="error-state__action">
        <ds-button-v2
          emphasis="primary"
          size="m"
          [fullWidth]="true"
          maxWidth="100%"
          [disabled]="retrying"
          [label]="texts.retryButton"
          (clicked)="retry.emit()"
        ></ds-button-v2>
      </div>

      <div class="error-state__action">
        <ds-button-v2
          [emphasis]="homeEmphasis"
          size="m"
          [fullWidth]="true"
          maxWidth="100%"
          [label]="texts.homeButton"
          (clicked)="goHome.emit()"
        ></ds-button-v2>
      </div>
    </div>
  </div>
</div>
